var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPermanentMicDisable(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#B6B6B6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_699_89)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2002 15.1997L32.8002 32.7997",
    stroke: "#F4F4F4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6006 21.5997V23.9997C21.601 24.4741 21.742 24.9377 22.0057 25.3319C22.2695 25.7262 22.6441 26.0335 23.0824 26.215C23.5207 26.3965 24.0029 26.444 24.4682 26.3516C24.9335 26.2591 25.3609 26.0309 25.6966 25.6957M26.4006 21.8717V17.5997C26.4012 17.0045 26.1806 16.4303 25.7817 15.9886C25.3828 15.5469 24.8339 15.2692 24.2418 15.2094C23.6496 15.1496 23.0564 15.312 22.5772 15.665C22.098 16.018 21.767 16.5364 21.6486 17.1197",
    stroke: "#F4F4F4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0005 27.9599C27.2196 28.757 26.2182 29.3027 25.125 29.5268C24.0318 29.7509 22.8966 29.6433 21.8649 29.2177C20.8333 28.7922 19.9523 28.0681 19.3351 27.1384C18.7178 26.2087 18.3924 25.1158 18.4005 23.9999V22.3999M29.6005 22.3999V23.9999C29.6003 24.3299 29.5708 24.6591 29.5125 24.9839",
    stroke: "#F4F4F4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 29.6001V32.8001",
    stroke: "#F4F4F4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8008 32.7998H27.2008",
    stroke: "#F4F4F4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_699_89"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.2,
    height: 19.2,
    fill: "white",
    transform: "translate(14.4004 14.3999)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermanentMicDisable);
export default __webpack_public_path__ + "static/media/permanent-mic-disable.2d0ecb6e78ce88e5d5b693d362311976.svg";
export { ForwardRef as ReactComponent };